var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.maxValue),function(i){return [(_vm.value >= i)?[_c('span',{key:i,staticClass:"fa fa-star",style:('color:' + _vm.color)})]:[_c('span',{key:i,staticClass:"fa fa-star-o",style:('color:' + _vm.colorEmpty)})]]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }